// ==========================================================================
// Plyr Media
// ==========================================================================

import html5 from './html5';
import vimeo from './plugins/vimeo';
import youtube from './plugins/youtube';
import starplayer from './plugins/starplayer';
import starplayerApp from './plugins/starplayer-app';
import activex from './plugins/activex';
import browser from './utils/browser';
import { createElement, toggleClass, wrap } from './utils/elements';

const media = {
  // Setup media
  setup() {
    return new Promise((resolve, reject) => {
      // If there's no media, bail
      if (!this.media) {
        this.debug.warn('No media element found!');
        return;
      }

      // Add type class
      toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', this.type), true); //'plyr--{0}'

      // Add provider class
      toggleClass(this.elements.container, this.config.classNames.provider.replace('{0}', this.provider), true); //'plyr--{0}'

      // Add video class for embeds
      // This will require changes if audio embeds are added
      if (this.isEmbed) {
        toggleClass(this.elements.container, this.config.classNames.type.replace('{0}', 'video'), true); //'plyr--{0}'
      }

      // Inject the player wrapper
      if (this.isVideo) {
        // Create the wrapper div
        this.elements.wrapper = createElement('div', {
          class: this.config.classNames.video, //'plyr__video-wrapper'
        });

        // Wrap the video in a container
        wrap(this.media, this.elements.wrapper);

        // Poster image container
        this.elements.poster = createElement('div', {
          class: this.config.classNames.poster, //'plyr__poster'
          hidden: '',
        });

        this.elements.wrapper.appendChild(this.elements.poster);

        
      }

      if (this.isStarPlayer) {
        if (this.isVideo) {
          // error message container
          this.elements.message = createElement('div', {
            class: this.config.classNames.message,
            hidden: '',
          });

          this.elements.text = createElement('p');

          this.elements.message.appendChild(this.elements.text);

          this.elements.wrapper.appendChild(this.elements.message);
        }

        if (browser.isIE) {
          activex.setup.call(this);
          this.listeners.global();
          resolve();
          return;
        }

        if (browser.isAndroid || browser.isIos) {
          starplayerApp.setup.call(this);
          resolve();
          return;
        }

        starplayer.connectAgent
          .call(this)
          .then(() => {
            this.debug.log('Installed StarPlayerAgent.');
            starplayer.setup.call(this);
            resolve();
          })
          .catch(() => {
            this.debug.log('Have to install StarPlayerAgent.');
            reject();
          });
      } else {
        if (this.isHTML5) {
          html5.setup.call(this);
        } else if (this.isYouTube) {
          youtube.setup.call(this);
        } else if (this.isVimeo) {
          vimeo.setup.call(this);
        }
        resolve();
      }
    });
  },
};

export default media;
